import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AuthCallback } from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Workspace from "@/pages/Workspace";
import Subscribe from "@/pages/Subscribe";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { MemberRoute } from "@/components/Billing";
import BillingHistory from "@/pages/BillingHistory";
import Team, { JoinTeam, JoinGate } from "@/pages/Team";
import SharePage from "@/pages/SharePage";
import AdminPanel from "@/pages/AdminPanel";
import { Disclaimer } from "@/components/Disclaimer";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/share/:token" element={<SharePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><PaymentCancel /></ProtectedRoute>} />
      <Route path="/join/:code" element={<JoinGate><ProtectedRoute><JoinTeam /></ProtectedRoute></JoinGate>} />
      <Route path="/billing" element={<MemberRoute><BillingHistory /></MemberRoute>} />
      <Route path="/team" element={<MemberRoute><Team /></MemberRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPanel /></ProtectedRoute>} />
      <Route path="/dashboard" element={<MemberRoute><Dashboard /></MemberRoute>} />
      <Route path="/project/:id" element={<MemberRoute><Workspace /></MemberRoute>} />
    </Routes>
    {!location.pathname.startsWith("/project/") && <Disclaimer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#182030", border: "1px solid #26334D", color: "#F1F5F9", fontFamily: "IBM Plex Sans" } }} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
